import { VehicleOutput } from '@allocab/allocab-driver-service-types';

import { assertNever } from './common';
// import BerlinePanelImage from '../assets/images/vehicle/berline.png';
import BusinessPanelImage from '../assets/images/vehicle/business.png';
import GreenPanelImage from '../assets/images/vehicle/green.png';
import MotoPanelImage from '../assets/images/vehicle/moto.png';
import TaxiPanelImage from '../assets/images/vehicle/taxi.png';
import VanAccessPanelImage from '../assets/images/vehicle/van-access.png';
import VanPanelImage from '../assets/images/vehicle/van.png';
import VaoPanelImage from '../assets/images/vehicle/vao.png';
import { t } from '../services/translation/translation';

export const getVehicleText = (vehicle: VehicleOutput) => (
  <span>
    <span className="font-mono text-xs font-bold">{vehicle.licensePlate}</span>
    {` - ${vehicle.brand} ${vehicle.range}`}
  </span>
);

export const getEngineTypeText = (engineType: VehicleOutput['engineType']) => {
  switch (engineType) {
    case 'GASOLINE':
      return t('engine-type.gasoline');
    case 'DIESEL':
      return t('engine-type.diesel');
    case 'ELECTRIC':
      return t('engine-type.electric');
    case 'SIMPLE_HYBRID':
      return t('engine-type.simple-hybrid');
    case 'PLUGIN_HYBRID':
      return t('engine-type.plugin-hybrid');
    case undefined:
      return t('common.unknown');
    default:
      assertNever(engineType, '[getEngineTypeText] engineType unknown');
      return t('common.unknown');
  }
};

export const getPanelImage = (panelKeys: VehicleOutput['panelKeys']) => {
  if (!panelKeys) return GreenPanelImage;

  if (panelKeys.includes('MOTO')) return MotoPanelImage;
  if (panelKeys.includes('VAN_ACCESS')) return VanAccessPanelImage;
  if (panelKeys.includes('ACCESS')) return VanAccessPanelImage;
  if (panelKeys.includes('VAN')) return VanPanelImage;
  if (panelKeys.includes('VAO')) return VaoPanelImage;
  if (panelKeys.includes('BUSINESS')) return BusinessPanelImage;
  if (panelKeys.includes('TAXI')) return TaxiPanelImage;
  if (panelKeys.includes('GREEN')) return GreenPanelImage;

  return GreenPanelImage;
};

export const getVehicleName = (vehicle: Pick<VehicleOutput, 'range' | 'brand'>) =>
  !vehicle.brand && !vehicle.range ? t('common.unknown') : `${vehicle.brand} ${vehicle.range}`;

export const formatLicencePlateNumber = (plateNumber: string) => {
  if (plateNumber.length < 3) return plateNumber.toUpperCase();

  const trimPlate = plateNumber.replace('-', '');
  if (trimPlate.length < 6) {
    if (/^[A-Za-z]{0,2}\d{0,3}$/.test(trimPlate)) {
      return `${trimPlate.slice(0, 2)}-${trimPlate.slice(2)}`.toUpperCase();
    }
  } else {
    if (/^[A-Za-z]{0,2}\d{0,3}[A-Za-z]{0,2}$/.test(trimPlate)) {
      return `${trimPlate.slice(0, 2)}-${trimPlate.slice(2, 5)}-${trimPlate.slice(5)}`.toUpperCase();
    }
  }

  return plateNumber.toUpperCase();
};
